import { categoryConfigurations } from './categoryConfig';

const categoryEmojiMap: Record<string, React.ReactNode | string> =
  Object.fromEntries(
    categoryConfigurations.map((config) => {
      const value = config.emoji;
      return [config.key, value];
    })
  );

export function getCategoryEmoji(
  category: string
): React.ReactNode | string | undefined {
  // Try exact match first
  if (categoryEmojiMap[category]) {
    return categoryEmojiMap[category];
  }

  // Try parent categories by removing segments from right to left
  const segments = category.split('.');
  while (segments.length > 1) {
    segments.pop();
    const parentCategory = segments.join('.');
    if (categoryEmojiMap[parentCategory]) {
      return categoryEmojiMap[parentCategory];
    }
  }

  // Return undefined if no match found
  return '❓';
}

export { categoryEmojiMap };
